import { Stack } from '@mui/material';

export default function CampStepsBox({
  direction,
  alignItems,
  gap,
  children,
  active = false,
  sx = {},
  bgGray = false,
  spacing,
}) {
  return (
    <Stack
      direction={direction || 'row'}
      gap={gap || 0}
      alignItems={alignItems || 'center'}
      justifyContent="space-between"
      spacing={spacing}
      sx={{
        mt: 3,
        ...(active ? { bgcolor: '#F5F4FF' } : { bgcolor: bgGray ? '#F0F0F7' : '#fff' }),
        borderRadius: 3,
        px: 3,
        py: 1,
        border: '1px solid',
        borderColor: active ? '#6152F1' : '#95A2B0',
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
}
